<template>
  <div class="carduseMain">
    <div class="tab-box">
      <div class="tab-item" @click="handleClickTab(index)" :class="{'tab-item_actived': index == tabIndex}"
           v-for="(item,index) in tabList" :key="`tab-item_${index}`">{{ item.name }}
      </div>
    </div>
    <div class="content">
      <div class="list-item" v-for="(item,index) in tableData" :key="`list-item_${index}`">
        <div class="before">
          <div class="type">{{ item.column1 || '-' }}</div>
          <div class="time">{{ item.column4 }}</div>
        </div>
        <div>
          <div class="money">
            {{ handleControlNumber(item.column3 || 0, 2) || '0.00' }}元
          </div>
          <div class="type3" v-if="tabIndex == 0 && item.column5 == 3">
            后台充值
          </div>
          <div class="type0" v-if="tabIndex == 0 && item.column5 == 0">
            前台充值
          </div>

        </div>
        
      </div>
      <div class="more" v-if="tableData.length == 0">暂无更多</div>
    </div>

  </div>
</template>
<script>
import {getRechargeRecods, getUseRecods} from "@/api/newApi";
import {formatDate} from "@/utils/formart";
import {digitUtil} from "@/utils/utils"

export default {
  name: "",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      tabList: [
        {name: "充值记录"},
        {name: "使用记录"},
      ],
      tabIndex: 0,
      tableData: [],
      getList: null,
    };
  },
  created() {
    this.tabIndex = this.$route.query.type;
    this.getDataList()
  },
  mounted() {
    this.getUseRecods();
  },
  methods: {
    handleControlNumber: digitUtil,
    getDataList() {
      this.tableData = [];

      this.getList = {
        0: getRechargeRecods,
        1: getUseRecods
      }[this.tabIndex]

      this.getList({
        cardNo: this.$route.params.id,
        pageNo: 1,
        pageSize: 10,
      }).then(res => {
        if (res.data.records.length > 0) {

          if(this.tabIndex == 0){
              res.data.records.map((item) => {
                 let tmp = {
                  column1: item.cardNo,
                  column2: item.mobile,
                  column3: item.amount,
                  column4: item.time,
                  column5: item.type,
                };

                this.tableData.push(tmp);
              });
          }

          if(this.tabIndex == 1){
              res.data.records.map((item) => {
                 let tmp = {
                  column1: item.cardNo,
                  column2: item.userName,
                  column3: item.amount,
                  column4: item.createTime,
                };

                this.tableData.push(tmp);
              });
          }

          console.log("tableData", this.tableData)
        }

      })
    },
    handleClickTab(index) {
      this.tabIndex = index;
      this.getDataList()
    },
    getUseRecods() {
      getRechargeRecods({
        cardNo: this.$route.params.id,
        pageNo: 1,
        pageSize: 10,
      }).then((res) => {
        if (res.data.records.lenght > 0) {
          this.tableData = res.data.records.map((item) => {
            return {
              cardNo: item.cardNo,
              mobile: item.mobile,
              amount: item.amount,
              createTime: item.createTime,
            };
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.carduseMain {
  padding: 0 $divPadding;
  min-height: 100%;
  background-color: #F5F5F6;

  .tab-box {
    display: flex;
    justify-content: space-around;

    .tab-item {
      padding: $divPadding;

    }

    .tab-item_actived {
      position: relative;
      color: #165DFF;

      &:before {
        content: '';
        position: absolute;
        bottom: 20%;
        left: 0;
        right: 0;
        margin: 0 auto;
        background-color: #165DFF;
        height: 3px;
        width: 20%;
        border-radius: 1rem;
      }
    }
  }

  .content {
    background-color: white;
    border-radius: $borderRadius;
    padding: $divPadding;
    padding-bottom: 0.7rem;

    .list-item {

      display: flex;
      padding: $divPadding 0;
      border-bottom: 1px solid #ECECEC;


      &:first-child {
        padding-top: 0;
      }

      .before {
        flex: 1;

        .type {
          color: #3D3D3D;
          font-size: 0.3783rem;
        }

        .time {
          margin-top: 0.1rem;
          color: #888888;
          font-size: 0.3243rem;
        }
      }

      .money {
        text-align: right;
      }
    }

    .more {
      padding: 0.2rem;
      text-align: center;
      font-size: 0.3243rem;
      color: #cccccc;
    }
  }
}


.type3{
  background-color: #f0f9eb;
  border-color: #e1f3d8;
  color: #67c23a;
  height: 24px;
  padding: 0 8px;
  line-height: 22px;
}

.type0{
  background-color: #eff2fe;
  border-color: #dfe5fe;
  color: #5f7df9;
  height: 24px;
  padding: 0 8px;
  line-height: 22px;
}


</style>
